@if ({layout: layout$ | async, scrolled: scrolled$ | async}; as ctx) {
  <div>
    <div
      [ngClass]="{
        'bg-bgo-blue-lightest': ctx.layout?.backgroundColour === 'blue',
        'layout-navbar--transparent': ctx.layout?.transparentNavbar,
        'layout-navbar--scrolled': ctx.scrolled === 'scrolling'
      }"
    >
      @if ({banner: announcementBanner$ | async}; as ctx2) {
        @if (ctx2.banner && !ctx.layout?.hideNavbar && !ctx.layout?.navAdminMode) {
          <bgo-announcement-banner
            [id]="ctx2.banner.id!"
            [text]="ctx2.banner.textMessage!"
            [linkText]="ctx2.banner.linkText!"
            [link]="ctx2.banner.link!"
          ></bgo-announcement-banner>
        }
      }
      @if (!ctx.layout?.hideNavbar && !ctx.layout?.navAdminMode) {
        <bgo-parent-brand-banner></bgo-parent-brand-banner>
      }
      <header class="sticky top-0 z-40" #header>
        @if (!ctx.layout?.hideNavbar) {
          <bgo-navbar />
        }
      </header>
      <main
        [ngClass]="{
          'h-layout v-layout': !ctx.layout?.optOutOfLayout && !ctx.layout?.navAdminMode
        }"
        [class.content]="!ctx.layout?.showMinimalistFooter"
        [class.content-min-footer]="ctx.layout?.showMinimalistFooter"
      >
        <div
          [ngClass]="{
            '-mt-navbar-thin-with-banner sm:-mt-navbar-with-banner':
              ctx.layout?.transparentNavbar && !ctx.layout?.hideNavbar
          }"
        >
          <router-outlet bgoBroadcastActivateEvents></router-outlet>
        </div>
      </main>
      @defer (on hover(header); prefetch on idle) {
        <bgo-navbar-side-menu></bgo-navbar-side-menu>
      }
      @defer (on viewport) {
        <bgo-footer />
      } @placeholder {
        <div></div>
      }
      <!-- we have this one instance of the offering search that should always load - we use it on all pages-->
      @defer (on idle) {
        <bgo-layout-search />
      }
    </div>
  </div>
}
@if (structuredData$ | async; as json) {
  <bgo-json-ld [json]="json"></bgo-json-ld>
}
